<template>
  <Modal v-on="$listeners" v-bind="$attrs" :large="true">
    <template v-slot:title>
      <i class="fas fa-key mr-2"></i> Encryption enabled
    </template>
    <template v-slot:body>
      <div>
        <div class="alert alert-danger alert-dismissible show" role="alert" v-if="showAlert">
          <button type="button" class="close" data-dismiss="alert" aria-label="Close" @click="showAlert=false">
            <span aria-hidden="true">&times;</span>
          </button>
          The passphrase you entered is not correct.
        </div>
        <div class="form-group">
          <label for="passphrase">Your notes are encrypted. Please enter your encryption passphrase to continue</label>
          <input type="password" class="form-control" id="passphrase" placeholder="Encryption passphrase" v-model="passphrase" />
        </div>
        <button class="btn btn-primary" @click="calculateClientKey" :disabled="decrypting">
          <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true" v-if="decrypting"></span>
          Decrypt notes
        </button>
        <button class="ml-2 btn btn-secondary" @click="signOut">Sign out</button>
      </div>
    </template>
  </Modal>
</template>
<script>
import Modal from '@/components/Modal'
import { signOut } from '@/utils/services'

import { calculateClientKey, verifyClientKey } from '@/utils/crypto'
export default {
  components: {
    Modal
  },
  data() {
    return {
      passphrase: '',
      showAlert: false,
      decrypting: false
    }
  },
  computed: {
    encryptedEncryptionKey() {
      return this.$store.state.encryption.encryptedEncryptionKey
    }
  },
  mounted() {
    document.addEventListener('keydown', event => {
      if (event.key === 'Enter') this.calculateClientKey()
    })
  },
  methods: {
    async calculateClientKey() {
      const clientKey = calculateClientKey(this.passphrase)
      this.clientKeyValid = verifyClientKey(this.encryptedEncryptionKey, clientKey)
      this.showAlert = !this.clientKeyValid
      if (this.clientKeyValid) {
        this.decrypting = true
        const userUid = this.$store.state.user ? this.$store.state.user.uid : null
        await this.$store.dispatch('encryption/setClientKey', { clientKey, userUid })
        await this.$store.dispatch('initialize', this.$store.state.user)
      }
    },
    signOut() {
      this.$store.commit('encryption/setEncryptedEncryptionKey', null)
      signOut()
    }
  }
}
</script>
